import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ApicallService } from '../services/apicall.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(public apiCallService: ApicallService, private router: Router) { }

  canActivate(){
    if(this.apiCallService.loggedIn() && this.apiCallService.user == undefined){
      this.apiCallService.loadUser();
      this.apiCallService.loadPath();
      this.apiCallService.loadToken();
    }
    if (!this.apiCallService.loggedIn()) {
      return false;
    } else {
      return true;
    }
  }


}
